import React from 'react';
import classNames from 'classnames';
import { ContentType } from 'types/publishedAssets';
import { resolveContentSize } from './contentSize';
import styles from './ContentContainer.module.scss';

interface Props {
  content: ContentType;
  children: React.ReactNode;
  className?: string;
}

export const SMALL = 640;
export const MEDIUM = 858;
export const LARGE = 1140;
export const FULL = 1920;

const SIZE_STYLE_MAP: Record<string, string> = {
  small: styles.small,
  medium: styles.medium,
  large: styles.large,
  full: styles.full,
};

export function ContentContainer({ content, children, className }: Props) {
  const size = resolveContentSize(content?.content_type, content?.metadata?.size);
  // Exposed as an attribute so a child can style itself against the width it is actually rendering
  // at — the block heading insets itself at `full`, where the container bleeds past the gutter.
  return (
    <div className={classNames(SIZE_STYLE_MAP[size], className)} data-content-size={size}>
      {children}
    </div>
  );
}
